export enum CollectionNameEnum {
  OPERATOR_PURCHASE_OFFER = 'OperatorPurchaseOffer',
  SOURCING_REQUEST = 'SourcingRequest',
  OPERATOR = 'Operator',
  USER = 'User',
  AIRCRAFT = 'Aircraft',
}
